(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews-trust-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('reviews-trust-grid');
  if (!root) return;

  function init() {
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var el = root.querySelector('.rtg-swiper');
    if (!isMobile || !el || el.dataset.inited === '1' || !window.Swiper) return;

    new Swiper('#reviews-trust-grid .rtg-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: { delay: 6000, disableOnInteraction: false }, // 6s like the reference
      pagination: { el: '#reviews-trust-grid .swiper-pagination', clickable: true },
      observer: true,
      observeParents: true
    });

    el.dataset.inited = '1';
  }

  // Run when DOM is ready, on full load, and whenever the breakpoint flips
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  var mq = window.matchMedia('(max-width: 767px)');
  (mq.addEventListener ? mq.addEventListener : mq.addListener).call(mq, 'change', init);

  // Retry for up to ~10s if Swiper loads late
  var tries = 0, t = setInterval(function(){
    if (++tries > 40) return clearInterval(t);
    init();
  }, 250);
})();

  } catch(e) { console.error(e); }
})();
})();
